import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import card1 from "../../../assets/centrum_assets/design/index/thirdFirst.png";
import card2 from "../../../assets/centrum_assets/design/index/thirdSECONDITEM.png";
import card3 from "../../../assets/centrum_assets/design/index/thirdTHIRDITEM.png";
import thirdimage from "../../../assets/images/home/thirdBG.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const SectionFour = () => {
  const cardData = [
    {
      image: card1,
      title: "HIGHEST QUALITY FUELS",
      content: [
        "The perfect product for every situation.",
        "Our team of engineers make sure that all our products meet the highest quality standards.",
      ],
      link: true,
    },
    {
      image: card2,
      title: "FULLY SYNTHETIC ENGINE OILS",
      content: ["The right choice for better engine performance."],
      link: false,
    },
    {
      image: card3,
      title: "COMMERCIAL SALES",
      content: ["Reliable partner in the energy sector."],
      link: false,
    },
  ];

  return (
    <Box
      sx={{
        backgroundImage: `url(${thirdimage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#1c1c1c",
        position: "relative",
        overflow: "hidden",
        pb: 5,
      }}
    >
      <Container maxWidth="lg" sx={{ px: { sm: 5 } }}>
        <Grid container spacing={8} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={4} textAlign="left">
            <Typography
              variant="h5"
              sx={{
                mb: 0.5,
                fontWeight: "bold",
                color: "#00b5e2",
                mt: { lg: 10, xs: 5 },
                mx: { xs: 3, sm: 0 },
              }}
            >
              FUEL YOUR JOURNEY
            </Typography>

            <Typography
              variant="h2"
              fontWeight={800}
              sx={{ color: "#0a1a3b", mx: { xs: 3, sm: 0 } }}
            >
              WHAT WE OFFER
            </Typography>
          </Grid>

          <Grid item xs={12} md={6} textAlign="left">
            <Typography
              sx={{
                color: "#3a3a3a",
                lineHeight: 1.5,
                fontSize: 18,
                letterSpacing: 1,
                mx: { xs: 3, sm: 0 },
                mt: { lg: 10, md: 4, xs: -7 },
              }}
            >
              With our innovative technologies, clear focus on the needs of our
              customers, and deep understanding of market dynamics, we are able
              to provide our customers with the best petroleum products at
              competitive prices.
            </Typography>
          </Grid>
        </Grid>

        <Grid container justifyContent="center" sx={{ mt: 5, mb: 10 }}>
          <Box sx={{ 
            width: "100%", 
            position: "relative",
            "& .swiper-pagination": {
              bottom: "0px !important",
            },
          }}>
            <Swiper
              modules={[Pagination]}
              spaceBetween={30}
              pagination={{ clickable: true }}
              breakpoints={{
                0: { slidesPerView: 1 },
                600: { slidesPerView: 2 },
                900: { slidesPerView: 3 },
                1200: { slidesPerView: 3 },
              }}
              style={{ width: "100%" }}
            >
              {cardData.map((card, index) => (
                <SwiperSlide key={index} style={{ display: "flex", justifyContent: "center" }}>
                  <Box
                    sx={{
                      position: "relative",
                      mx: { xs: 3, sm: 0 },
                      borderRadius: 2,
                      overflow: "hidden",
                      backgroundColor: "#fff",
                      cursor: "pointer",
                      height: "400px",
                      width: "100%",
                      maxWidth: "420px",
                      border: "1px solid #4444",
                      "&:hover .textBox": {
                        transform: "translateY(0)",
                        height: "220px",
                      },
                      "&:hover .hidden-text": {
                        opacity: 1,
                        transform: "translateY(0)",
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src={card.image}
                      alt={card.title}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        transition: "filter 0.3s ease-in-out",
                      }}
                    />

                    <Box
                      className="textBox"
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        // FIX: Pinalitan ang width at dinagdagan ng boxSizing
                        width: "100%", 
                        boxSizing: "border-box", 
                        backgroundColor: "#fff",
                        p: 3,
                        height: "190px",
                        transform: "translateY(70px)",
                        transition: "all 0.4s ease-in-out",
                        zIndex: 1,
                        textAlign: "left",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#8dc63f",
                          fontWeight: 700,
                          fontSize: 15,
                          mb: 1.5,
                          letterSpacing: 1.1,
                        }}
                      >
                        {card.title}
                      </Typography>

                      {card.content.map((line, i) => (
                        <Typography
                          key={i}
                          className={i > 0 ? "hidden-text" : ""}
                          variant="body1"
                          sx={{
                            color: i > 0 ? "#888" : "#1c1c1c",
                            fontSize: 15,
                            fontWeight: 500,
                            lineHeight: 1.6,
                            mt: i === 1 ? 2 : 1,
                            ...(i > 0 && {
                              opacity: 0,
                              transition: "opacity 0.4s ease-in-out, transform 0.4s ease-in-out",
                            }),
                          }}
                        >
                          {line}
                        </Typography>
                      ))}

                      {card.link && (
                        <Typography
                          component={Link}
                          to="/solutions"
                          className="hidden-text"
                          sx={{
                            color: "#7bb241",
                            "&:hover": { color: "#00b5e2" },
                            letterSpacing: "0.08em",
                            fontSize: "13px",
                            fontWeight: "bold",
                            mt: 3,
                            display: "inline-block",
                            opacity: 0,
                          }}
                        >
                          LEARN MORE →
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        </Grid>
      </Container>
    </Box>
  );
};

export default SectionFour;